import { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import queryString from "query-string";
import { updateCashierWithdrawal } from "../../../redux/actions/userActions";

const Step = props => {
  useEffect(() => {
    let returnQS = decodeURIComponent(props.location.search);
    let returnData = queryString.parse(returnQS);
    // console.log("returnData");
    // console.log(returnData);
    props.updateCashierWithdrawal(returnData);
  }, [props.location.search]);

  useEffect(() => {
    if (Object.keys(props.success).length > 0) {
      // console.log("/withdraw-funds/success");
      window.location.href = "/withdraw-funds/success";
    }

    if (Object.keys(props.errors).length > 0) {
      // console.log("/withdraw-funds/failed");
      window.location.href = "/withdraw-funds/failed";
    }
  }, [props]);

  return null;
};

Step.propTypes = {
  auth: PropTypes.object.isRequired,
  updateCashierWithdrawal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  success: state.success,
  errors: state.errors,
});

export default connect(mapStateToProps, { updateCashierWithdrawal })(Step);
